import { createFileRoute } from '@tanstack/react-router';
import DashboardPage from '../../components/pages/dashboard';
import { requireAccess } from '../../auth/authUtils';

export const Route = createFileRoute('/dashboard/')({
  component: DashboardPage,
  head: () => ({
    meta: [
      {
        title: 'Dashboard | Ingle Lewer',
      },
    ],
  }),
  beforeLoad: async ({ context }) => {
    requireAccess(context);
  },
});
